import $ from 'jquery';
import DataTable from 'datatables.net-bs5';

const tenderNotice = {
    data: {
        tenderData: {},
        archiveData: {}
    },
    methods: {
        createTableHeader: function (headers, tableEl) {
            const theadEl = $(tableEl).find('thead');
            theadEl.html(`
                <tr>
                ${headers.map((el) => `<th>${el}</th>`).join('')}
                </tr>
            `);
        },
        createTableBody: function (tableEl, data, tableHeaders) {
            const tbodyEl = $(tableEl).find('tbody');
            tbodyEl.html('');

            // The PDF link is an icon only, so it is named after the tender
            // (WCAG 2.4.4, 4.1.2).
            const titleKey = tableHeaders.find((el) => /title|subject|name|description|particular/i.test(el))
                || tableHeaders.find((el) => el !== 'Related Document' && el !== 'Status');
            const escapeAttr = (text) => String(text == null ? '' : text).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

            $.each(data, (idx, obj) => {
                const statusColor = obj.Status === 'Closed' ? 'text-red' : 'text-green';
                const linkName = escapeAttr(`Download ${obj[titleKey] ? obj[titleKey] + ' ' : ''}(PDF)`);
                tbodyEl.append(`<tr>
                    ${tableHeaders.map((el) => {
                        if (el === 'Related Document') {
                            return `<td><a href="${obj[el]}" aria-label="${linkName}" onclick="openAndDownloadPDF('${obj[el]}'); return false;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" fill="#0C73B4" aria-hidden="true" focusable="false" class="bi bi-filetype-pdf" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"/>
                                </svg>
                            </a></td>`;
                        } if (el === 'Status') {
                            return `<td class="${statusColor}">${obj[el]}</td>`;
                        } else {
                            return `<td>${obj[el]}</td>`;
                        }
                    }).join('')}
                </tr>`);
            });
        },
        initializeTable: function (data, tableEl) {
            const createTableHead = tenderNotice.methods.createTableHeader;
            const createTableBody = tenderNotice.methods.createTableBody;
            if (data.length) {
                const tempData = data[0];
                const tableHeaders = Object.keys(tempData);
                createTableHead(tableHeaders, tableEl);
                createTableBody(tableEl, data, tableHeaders);
                if ($.fn.dataTable.isDataTable(tableEl)) {
                    $(tableEl).DataTable();
                } else {
                    const dataTable = $(tableEl).DataTable({
                        paging: false,
                        info: false,
                        searching: true,
                        ordering: false,
                        layout: {
                            topEnd: null
                        }
                    });
                    $(tableEl).find('tbody th').parent().hide();
                    $(tableEl).parent().addClass('table-container');
                    tenderNotice.methods.getResult(dataTable, tableEl);
                }
            }
        },
        getResult: function (dataTable, tableEl) {
            const inputEl = $(tableEl).closest('.tender-notice__wrapper').find(".tender-notice__input").get(0);
            dataTable = dataTable.rows('tr:first-child').remove();
            $(inputEl).off('keyup').on('keyup', function () {
                dataTable.search($(inputEl).val()).draw();
            });
        },
        fetchData: function (path, type, el) {
            return $.ajax({
                url: `/bin/chli/tenderNoticeJson?path=${path}/${type}`,
                dataType: 'json',
                type: 'POST',
            }).done((response) => {
                tenderNotice.data[`${type}Data`][path] = response;
                tenderNotice.methods.initializeTable(response, $(el).find(`table.tender-notice__table-${type}`).get(0));
            }).fail(() => {
                console.log(`Error occurred while fetching ${type} data for path: ${path}`);
            });
        },
        fetchInitialTenderData: function () {
            $('.tender-notice__wrapper').each((idx, el) => {
                const assetPath = $(el).data("assetpath");
                if (!tenderNotice.data.tenderData[assetPath]) {
                    tenderNotice.methods.fetchData(assetPath, 'tender', el);
                } else {
                    tenderNotice.methods.initializeTable(tenderNotice.data.tenderData[assetPath], $(el).find('table.tender-notice__table-tender').get(0));
                }
                $(el).find('#latestTenderContent').addClass('active');
                $(el).find('#archiveContent').removeClass('active');
                tenderNotice.methods.toggleContent(el);
            });
        },
        toggleContent: function (el) {
            const latestTenderBtn = $(el).find('#latestTenderBtn');
            const archiveBtn = $(el).find('#archiveBtn');
            const primaryBar = $(el).find('.tender-notice_primary-bar');
            const wrapper = $(el);

            latestTenderBtn.on('click', function () {
                latestTenderBtn.addClass('active');
                archiveBtn.removeClass('active');
                primaryBar.css('left', '0');
                wrapper.find('tbody').empty();
                const assetPath = wrapper.data("assetpath");
                if (!tenderNotice.data.tenderData[assetPath]) {
                    tenderNotice.methods.fetchData(assetPath, 'tender', wrapper);
                } else {
                    tenderNotice.methods.initializeTable(tenderNotice.data.tenderData[assetPath], wrapper.find('table.tender-notice__table-tender').get(0));
                }
                wrapper.find('#latestTenderContent').addClass('active');
                wrapper.find('#archiveContent').removeClass('active');
            });

            archiveBtn.on('click', function () {
                latestTenderBtn.removeClass('active');
                archiveBtn.addClass('active');
                primaryBar.css('left', '50%');
                wrapper.find('tbody').empty();
                const assetPath = wrapper.data("assetpath");
                if (!tenderNotice.data.archiveData[assetPath]) {
                    tenderNotice.methods.fetchData(assetPath, 'archive', wrapper);
                } else {
                    tenderNotice.methods.initializeTable(tenderNotice.data.archiveData[assetPath], wrapper.find('table.tender-notice__table-archive').get(0));
                }
                wrapper.find('#latestTenderContent').removeClass('active');
                wrapper.find('#archiveContent').addClass('active');
            });
        },

         downloadPdfClickHandler: function (e) {
              $(document).on('click', '.bi' ,function () {
                 if($(this).hasClass('bi-filetype-pdf')){
                    var obj = tenderNotice.methods.dataLayerObj();
                    createDataLayer('Download_NonProduct', obj);
                 }
              });
            },

         tenderSearchClickedHandler: function(){
                           $('.tender-notice__input').on('focus', function() {
                             let buttonText = $(this).val();
                             let section = $(this).closest('.tender-notice__input');
                             let titleText = section.find('.heading-2').text().trim();
                             let obj = tenderNotice.methods.dataLayerObj(buttonText,titleText);
                              createDataLayer('searchClicked',obj);
                           });
                      },

             tenderSearchKeywordHandler: function(){
                  let timeout;

                 $(document).on('keyup', '.tender-notice__input', function() {
                         const $this = $(this);
                         clearTimeout(timeout);
                         timeout = setTimeout(function() {
                             let buttonText = $this.val();
                             let section = $this.closest('.tender-notice__input');
                             let titleText = section.find('.heading-2').text().trim();
                             let obj = tenderNotice.methods.dataLayerObj(buttonText, titleText);
                             createDataLayer('enter_search_keyword', obj);
                         }, 3000);
                     });

             },

              dataLayerObj: function (e) {
                  var obj = {
                    'articleName': "",
                    'blogCategory': "",
                    'blogPageCategory': "",
                    'buttonText': "",
                    'pageSection': "Tender Notices",
                    'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                    'planOption': "",
                    'productCategory': "",
                    'productName': "",
                    'question': "",
                    'source': "",
                    'searchTerm': e ? e : "",
                    'videoTitle': "",
                    'bannerName': "",
                  };
                  return obj;
                },

        init: function () {
            this.fetchInitialTenderData();
        }
    }
};

window.openAndDownloadPDF = function (url) {
    window.open(url, '_blank');
};

$(() => {
    tenderNotice.methods.init();
    tenderNotice.methods.downloadPdfClickHandler();
    tenderNotice.methods.tenderSearchClickedHandler();
    tenderNotice.methods.tenderSearchKeywordHandler();
});
